module.exports = __webpack_public_path__ + "img/close-with-circle.341dc254.svg";